<template>
  <div class="container">
    <div class="head">
      <div class="search">
        <div class="ipt">
          <input v-model="inputParams" placeholder="投诉单号/投诉人姓名/被投诉对象名称" />
        </div>
        <div class="search-btn" @click="$router.push({path:'/appraise/search', query:{inputParams}})">查询</div>
      </div>
      <div class="cs-sort">
        <div class="by-time" @click="showTime()">{{timeName}}</div>
        <div class="by-state"  @click="showStatus()">已办结</div>
      </div>
    </div>

    <div class="list">
      <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="loadMoreList"
          v-if="complainList.length > 0"
          :offset="100"
          :error.sync="error"
        >
      <div class="item" v-for="(item,index) in complainList" :key="index">
        <div class="item-head">
          <div class="name">{{item.defendant_name}}</div>
          <div class="btn hg">{{item.statue_name}}</div>
        </div>

        <div class="item-cont">
          <div>投诉人：{{item.complain_name}}</div>
          <div>投诉单号：{{item.orderNo}}</div>
        </div>

        <div class="score">
          <div class="term">响应时长<span>{{item.answerTime}}分钟</span></div>
          <div class="term">办结时长<span class="red">{{(item.handle_time/(60*60)).toFixed(1)}}小时</span></div>
        </div>
      </div>
      </van-list>

    </div>
    <!-- 没有投诉记录提示 -->
    <div v-if="complainList.length===0 && !loading" class="noData-bg">
      <nodata :noData="noData"></nodata>
    </div>
    <common-picker ref="commonPickerTime" :typeList="timeList" :cols="cols1" @getTypeValue="getTimeValue"></common-picker>
    <common-picker ref="commonPickerStatus" :typeList="statusList" :cols="cols1" @getTypeValue="getStatusValue"></common-picker>
  </div>
</template>
<script>
    import nodata from './components/nodata';// 没有数据
    import commonPicker from '../../components/base/commonPicker'// picker选择
    import api from '../../service/modules/appraise';
    export default {
        components: {
            nodata,
            commonPicker
        },

        data () {
            return {
                finished: false,
                loading: false,
                urlInfo: {},
                cols1: 1,
                inputParams: '',
                noData: {
                    title: '没有投诉记录'
                },
                timeList: [[
                    {
                        value: 'create',
                        text: '按投诉时间排序'
                    },
                    {
                        value: 'finish',
                        text: '按办结时间排序'
                    }

                ]],
                statusList: [[

                    {
                        value: '50',
                        text: '已办结'
                    }
                ]],
                complainList: [],
                timeVal: 'create',
                statusVal: '',
                timeName: '按发起时间排序',
                statusName: '全部状态',
                page: 1,
                pageSize: 10,
                total: 0,
                error: false
            }
        },

        computed: {},

        watch: {},

        methods: {
            loadMoreList () {
                this.getList()
            },
            // 投诉件列表接口
            getList () {
                this.loading = true;

                api.notRespondDetail({
                    year: this.urlInfo.year,
                    quarter: this.urlInfo.quarter,

                    cityId: this.urlInfo.cityId,
                    curPage: this.page,
                    pageSize: this.pageSize,
                    inputParams: this.inputParams,
                    complainStatue: 50,
                    sort: this.timeVal,
                    type: 'notRespondDetail'
                }).then(res => {
                    if (res.ret === 0) {
                        this.loading = false;
                        this.complainList = this.complainList.concat(res.data.list)
                        this.page++;
                        this.total = res.data.total;
                        if (this.total <= this.page * this.pageSize) {
                            this.finished = true;
                        }
                    } else {
                        this.$Message.error('res.data.msg')
                    }
                });
            },
            // 选择时间排序
            getTimeValue (value) {
                this.page = 1
                this.pageSize = 10
                this.timeName = value[0].text
                this.timeVal = value[0].value
                this.complainList = []
                this.getList()
            },
            // 投诉状态排序
            getStatusValue (value) {
                this.page = 1
                this.pageSize = 10
                this.statusName = value[0].text
                this.statusVal = value[0].value
                this.complainList = []
                this.getList()
            },
            showTime () {
                this.$refs.commonPickerTime.showPicker();
            },
            showStatus () {
                this.$refs.commonPickerStatus.showPicker();
            }
        },

        mounted () {},

        created () {
            this.urlInfo = JSON.parse(sessionStorage.getItem('urlInfo'))
            this.getList()
            // bus.$on('getList', this.getList())
        }

    }
</script>
<style scoped lang="less">
  .container {
    min-height: 100vh;
    background: rgba(251, 251, 251, 1);
    display: flex;
    flex-direction: column;
    .noData-bg{
      display: flex;
      justify-content: center;
      align-items: center;
      flex: 1;
    }

    .head {
      background: #fff;
      padding: 12px 16px;
      margin-bottom: 24px;
      border-bottom:1px solid rgba(238,238,238,1);
      .search{
        display: flex;
        justify-content: space-between;
        align-items: center;
        .ipt{
          position: relative;
          flex: 1;
          height:36px;
          background:rgba(255,255,255,1);
          border-radius:3px;
          border:1px solid rgba(238,238,238,1);
          box-sizing: border-box;
          margin-top: 1px;
          input{
            width: 100%;
            height: 100%;
            font-size:14px;
            line-height: 34px;
            padding-left: 35px;
            box-sizing: border-box;
          }
          input::-webkit-input-placeholder{
            font-size:14px;
            font-family:PingFangSC-Regular,PingFang SC;
            font-weight:400;
            color:rgba(153,153,153,1);
          }
        }
        .ipt::before{
          content: '';
          position: absolute;
          left: 12px;
          top: 50%;
          margin-top: -7px;
          width: 15px;
          height: 14px;
          background: url(../../assets/image/search.png) no-repeat;
          background-size: 15px 14px;
        }
        .search-btn{
          width: 48px;
          text-align: right;
          font-size:14px;
          font-family:PingFangSC-Regular,PingFang SC;
          font-weight:400;
          color:rgba(51,51,51,1);
          line-height:36px;
          font-size: 10px;
        }
      }
      .cs-sort{
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 14px 48px 0 30px;
        div{
          position: relative;
          font-size:12px;
          font-family:PingFangSC-Regular,PingFang SC;
          font-weight:400;
          color:rgba(102,102,102,1);
          padding-right: 11px;
        }
        div::after{
          content:'';
          position: absolute;
          right: 0;
          top: 50%;
          transform: translateY(-50%);
          width: 6px;
          height: 4px;
          background: url(../../assets/image/jiantou.png) no-repeat;
          background-size: 6px 4px;
        }
      }
    }
    .list{
      padding: 0 12px 16px 12px;
      .item{
        background:rgba(255,255,255,1);
        box-shadow:0px 0px 10px 0px rgba(0,0,0,0.04);
        border-radius:3px;
        margin-bottom: 24px;
        &-head{
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 16px 16px 0 16px;
          .name{
            font-size:14px;
            font-family:PingFangSC-Semibold,PingFang SC;
            font-weight:bold;
            color:rgba(42,42,42,1);
            width: 240px;
            line-height: 16px;
          }
          .btn{
            min-width:46px;
            line-height: 18px;
            padding: 0 8px;
            background:rgba(255,140,25,1);
            border-radius:9px;
            text-align: center;
            color: #fff;
          }
          .dpj{
            background:rgba(255,140,25,1);
          }
          .hg{
            background:rgba(54,179,116,1);
          }
        }
        &-cont{
          padding: 16px;
          div{
            font-size:12px;
            font-family:PingFangSC-Regular,PingFang SC;
            font-weight:400;
            color:rgba(102,102,102,1);
            line-height:12px;
            margin-bottom: 12px;
          }
          div:last-child{
            margin-bottom: 0;
          }
        }
        .score{
          display: flex;
          height: 45px;
          border-top: solid 1px #EEEEEE;
          .term{
            position: relative;
            flex:1;
            line-height: 45px;
            text-align: center;
            font-size:14px;
            font-family:PingFangSC-Regular,PingFang SC;
            font-weight:400;
            color:#333333;
            span{
              padding-left: 4px;
            }
            .red{
              color: #FF4D4D;
            }
          }
          .term:first-child::after{
            content:'';
            position: absolute;
            right: 0;
            top: 50%;
            height: 12px;
            transform: translateY(-50%);
            border-right: solid 1px #999999;
          }
        }
      }
    }
  }
</style>
